var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroupSelect',{attrs:{"required":"","field":_vm.field,"items":_vm.cslist,"label":_vm.label,"value":_vm.value.name},on:{"change":_vm.change}},[_vm._v("Class Society")])}
var staticRenderFns = []

export { render, staticRenderFns }